/* eslint-disable max-len */
import * as React from 'react';
import { IconProps } from '../../common/types/componentTypes';

const SelectionToggleDisabledIcon: React.FC<IconProps> = ({ width = 20, height = 20, color = '#717887', ...props }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.875 3.3335C5.61676 3.3335 4.58333 4.36692 4.58333 5.62516V13.1252C4.58333 14.3834 5.61676 15.4168 6.875 15.4168H14.375C15.6332 15.4168 16.6667 14.3834 16.6667 13.1252V5.62516C16.6667 4.36692 15.6332 3.3335 14.375 3.3335H6.875ZM6.875 4.5835H14.375C14.9576 4.5835 15.4167 5.04257 15.4167 5.62516V13.1252C15.4167 13.7078 14.9576 14.1668 14.375 14.1668H6.875C6.29241 14.1668 5.83333 13.7078 5.83333 13.1252V5.62516C5.83333 5.04257 6.29241 4.5835 6.875 4.5835ZM3.75 5.41683L3.24219 5.75537C2.77844 6.06454 2.5 6.58501 2.5 7.14209V13.5418C2.5 15.7281 4.27208 17.5002 6.45833 17.5002H12.8581C13.4156 17.5002 13.936 17.2217 14.2448 16.758L14.5833 16.2502H6.45833C4.9625 16.2502 3.75 15.0377 3.75 13.5418V5.41683Z"
            fill={color}
        />
    </svg>
);

export default SelectionToggleDisabledIcon;
